import React, { useEffect, useState } from 'react';
import { Tag } from "../typings";
import { Row } from "../components/Flex";
import { createTag, fetchTags, removeTag } from "./tags-api";
import TagCard from "./TagCard";
import CreateTagDialog from "./CreateTagDialog";
import { toast } from "react-toastify";
import { useApi } from "../api-context";

function TagsPage() {
    const api = useApi();
    const [tags, setTags] = useState<Tag[]>([]);
    const [dialogOpen, setDialogOpen] = useState(false);

    const loadTags = () => {
        fetchTags(api)
            .then(tags => setTags(tags.filter(tag => !tag.predefined)))
            .catch((reason) => {
                if (reason !== 'Unauthorized') {
                    toast.error('Failed to load tags');
                }
            });
    };

    useEffect(() => {
        loadTags();
    }, []);

    const onCreateTag = (name: string) => {
        createTag(api, name)
            .then((id) => {
                setTags([...tags, { id, name, predefined: false, readOnly: false }]);
                toast.success('Successfully created tag');
            })
            .catch(() => toast.error('Failed to create tag'))
            .finally(() => {
                setDialogOpen(false);
            })
    };

    const onOpenDialog = () => setDialogOpen(true);
    const onCloseDialog = () => setDialogOpen(false);

    const onRemoveContent = (id: number) => {
        removeTag(api, id)
            .then(() => {
                setTags(tags.filter(tag => tag.id !== id));
                toast.success('Successfully removed tag');
            })
            .catch(() => toast.error('Failed to remove tag'));
    };

    return (
        <>
            <div className="page-container">
                <Row gap={8} style={{marginBottom: '32px'}}>
                    <div style={{ flex: 1 }} className="main-title">
                        Tags
                    </div>
                    <button
                        style={{ flex: 0, minWidth: '150px' }}
                        className="my-button"
                        onClick={onOpenDialog}
                    >
                        CREATE
                    </button>
                </Row>
                <div className="content-container" style={{ marginBottom: '32px' }}>
                    {tags.map((item) => (
                        <TagCard
                            api={api}
                            tags={tags}
                            key={item.id}
                            tag={item}
                            onRemove={onRemoveContent}
                        />
                    ))}
                </div>
            </div>
            <CreateTagDialog
                tags={tags}
                open={dialogOpen}
                onClose={onCloseDialog}
                onCreate={onCreateTag}
            />
        </>
    );
}

export default TagsPage;
